import {Box, Typography} from '@mui/material';
import RecruiterInfo, {RecruiterInfoProps} from './RecruiterInfo';

type JobTitleProps = {
  title: string;
  profilePicture?: string;
  recruiter: RecruiterInfoProps;
  date?: string;
  designation?: string;
};

const PendingTestsTitle = ({
  title,
  recruiter,
  profilePicture,
  date,
  designation,
}: JobTitleProps) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        data-testid="pending-assessment"
      >
        <Typography mb={{xs: 1.6, md: 2}} fontSize={{xs: 14, sm: 16}}>
          {title}
        </Typography>
        <RecruiterInfo
          name={recruiter.name}
          organization={recruiter?.organization}
          profilePicture={recruiter.profilePicture}
          date={recruiter.date}
          designation={recruiter.designation}
        />
      </Box>
    </>
  );
};

export default PendingTestsTitle;
